/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ShopifyDeliveryDefaults } from "./ShopifyDeliveryDefaults";
import {
  ShopifyDeliveryDefaultsFromJSON,
  ShopifyDeliveryDefaultsFromJSONTyped,
  ShopifyDeliveryDefaultsToJSON,
  ShopifyDeliveryDefaultsToJSONTyped,
} from "./ShopifyDeliveryDefaults";
import type { ShopifyPalletizationConfig } from "./ShopifyPalletizationConfig";
import {
  ShopifyPalletizationConfigFromJSON,
  ShopifyPalletizationConfigFromJSONTyped,
  ShopifyPalletizationConfigToJSON,
  ShopifyPalletizationConfigToJSONTyped,
} from "./ShopifyPalletizationConfig";
import type { CheckoutMarkup } from "./CheckoutMarkup";
import {
  CheckoutMarkupFromJSON,
  CheckoutMarkupFromJSONTyped,
  CheckoutMarkupToJSON,
  CheckoutMarkupToJSONTyped,
} from "./CheckoutMarkup";
import type { ShopifyDimensionMetafieldMapping } from "./ShopifyDimensionMetafieldMapping";
import {
  ShopifyDimensionMetafieldMappingFromJSON,
  ShopifyDimensionMetafieldMappingFromJSONTyped,
  ShopifyDimensionMetafieldMappingToJSON,
  ShopifyDimensionMetafieldMappingToJSONTyped,
} from "./ShopifyDimensionMetafieldMapping";
import type { ShopifyTagAccessorialRule } from "./ShopifyTagAccessorialRule";
import {
  ShopifyTagAccessorialRuleFromJSON,
  ShopifyTagAccessorialRuleFromJSONTyped,
  ShopifyTagAccessorialRuleToJSON,
  ShopifyTagAccessorialRuleToJSONTyped,
} from "./ShopifyTagAccessorialRule";
import type { ShopifyTagLocationTypeRule } from "./ShopifyTagLocationTypeRule";
import {
  ShopifyTagLocationTypeRuleFromJSON,
  ShopifyTagLocationTypeRuleFromJSONTyped,
  ShopifyTagLocationTypeRuleToJSON,
  ShopifyTagLocationTypeRuleToJSONTyped,
} from "./ShopifyTagLocationTypeRule";
import type { ShopifyHandlingTimeMetafieldMapping } from "./ShopifyHandlingTimeMetafieldMapping";
import {
  ShopifyHandlingTimeMetafieldMappingFromJSON,
  ShopifyHandlingTimeMetafieldMappingFromJSONTyped,
  ShopifyHandlingTimeMetafieldMappingToJSON,
  ShopifyHandlingTimeMetafieldMappingToJSONTyped,
} from "./ShopifyHandlingTimeMetafieldMapping";
import type { CheckoutRateSelector } from "./CheckoutRateSelector";
import {
  CheckoutRateSelectorFromJSON,
  CheckoutRateSelectorFromJSONTyped,
  CheckoutRateSelectorToJSON,
  CheckoutRateSelectorToJSONTyped,
} from "./CheckoutRateSelector";
import type { ShopifyPickupLocation } from "./ShopifyPickupLocation";
import {
  ShopifyPickupLocationFromJSON,
  ShopifyPickupLocationFromJSONTyped,
  ShopifyPickupLocationToJSON,
  ShopifyPickupLocationToJSONTyped,
} from "./ShopifyPickupLocation";

/**
 *
 * @export
 * @interface ShopifyFreightSettings
 */
export interface ShopifyFreightSettings {
  /**
   *
   * @type {CheckoutMarkup}
   * @memberof ShopifyFreightSettings
   */
  markup: CheckoutMarkup;
  /**
   *
   * @type {ShopifyDeliveryDefaults}
   * @memberof ShopifyFreightSettings
   */
  deliveryDefaults: ShopifyDeliveryDefaults;
  /**
   *
   * @type {string}
   * @memberof ShopifyFreightSettings
   */
  pickupLocationType: string;
  /**
   *
   * @type {string}
   * @memberof ShopifyFreightSettings
   */
  pickupDistributionWarehouseBrand?: string | null;
  /**
   *
   * @type {Array<string>}
   * @memberof ShopifyFreightSettings
   */
  pickupAccessorials: Array<string>;
  /**
   *
   * @type {Array<ShopifyPickupLocation>}
   * @memberof ShopifyFreightSettings
   */
  pickupLocations: Array<ShopifyPickupLocation>;
  /**
   *
   * @type {Array<string>}
   * @memberof ShopifyFreightSettings
   */
  allowedCarriers: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof ShopifyFreightSettings
   */
  blockedCarriers: Array<string>;
  /**
   *
   * @type {number}
   * @memberof ShopifyFreightSettings
   */
  maxHandlingUnits: number;
  /**
   *
   * @type {number}
   * @memberof ShopifyFreightSettings
   */
  maxRatesPerResponse: number;
  /**
   *
   * @type {Array<CheckoutRateSelector>}
   * @memberof ShopifyFreightSettings
   */
  rateSelectors: Array<CheckoutRateSelector>;
  /**
   *
   * @type {number}
   * @memberof ShopifyFreightSettings
   */
  handlingTimeBusinessDays: number;
  /**
   *
   * @type {ShopifyDimensionMetafieldMapping}
   * @memberof ShopifyFreightSettings
   */
  dimensionMetafields?: ShopifyDimensionMetafieldMapping | null;
  /**
   *
   * @type {boolean}
   * @memberof ShopifyFreightSettings
   */
  clearDimensionMetafields: boolean;
  /**
   *
   * @type {ShopifyHandlingTimeMetafieldMapping}
   * @memberof ShopifyFreightSettings
   */
  handlingTimeMetafield?: ShopifyHandlingTimeMetafieldMapping | null;
  /**
   *
   * @type {boolean}
   * @memberof ShopifyFreightSettings
   */
  clearHandlingTimeMetafield: boolean;
  /**
   *
   * @type {ShopifyPalletizationConfig}
   * @memberof ShopifyFreightSettings
   */
  palletization: ShopifyPalletizationConfig;
  /**
   *
   * @type {boolean}
   * @memberof ShopifyFreightSettings
   */
  ratesEnabled: boolean;
  /**
   *
   * @type {Array<ShopifyTagAccessorialRule>}
   * @memberof ShopifyFreightSettings
   */
  tagAccessorialRules: Array<ShopifyTagAccessorialRule>;
  /**
   *
   * @type {Array<ShopifyTagLocationTypeRule>}
   * @memberof ShopifyFreightSettings
   */
  tagLocationTypeRules: Array<ShopifyTagLocationTypeRule>;
  /**
   *
   * @type {Array<string>}
   * @memberof ShopifyFreightSettings
   */
  requiredCustomerTags?: Array<string> | null;
  /**
   *
   * @type {Array<string>}
   * @memberof ShopifyFreightSettings
   */
  excludedProductTags: Array<string>;
}

/**
 * Check if a given object implements the ShopifyFreightSettings interface.
 */
export function instanceOfShopifyFreightSettings(
  value: object,
): value is ShopifyFreightSettings {
  if (!("markup" in value) || value["markup"] === undefined) return false;
  if (!("deliveryDefaults" in value) || value["deliveryDefaults"] === undefined)
    return false;
  if (
    !("pickupLocationType" in value) ||
    value["pickupLocationType"] === undefined
  )
    return false;
  if (
    !("pickupAccessorials" in value) ||
    value["pickupAccessorials"] === undefined
  )
    return false;
  if (!("pickupLocations" in value) || value["pickupLocations"] === undefined)
    return false;
  if (!("allowedCarriers" in value) || value["allowedCarriers"] === undefined)
    return false;
  if (!("blockedCarriers" in value) || value["blockedCarriers"] === undefined)
    return false;
  if (!("maxHandlingUnits" in value) || value["maxHandlingUnits"] === undefined)
    return false;
  if (
    !("maxRatesPerResponse" in value) ||
    value["maxRatesPerResponse"] === undefined
  )
    return false;
  if (!("rateSelectors" in value) || value["rateSelectors"] === undefined)
    return false;
  if (
    !("handlingTimeBusinessDays" in value) ||
    value["handlingTimeBusinessDays"] === undefined
  )
    return false;
  if (
    !("clearDimensionMetafields" in value) ||
    value["clearDimensionMetafields"] === undefined
  )
    return false;
  if (
    !("clearHandlingTimeMetafield" in value) ||
    value["clearHandlingTimeMetafield"] === undefined
  )
    return false;
  if (!("palletization" in value) || value["palletization"] === undefined)
    return false;
  if (!("ratesEnabled" in value) || value["ratesEnabled"] === undefined)
    return false;
  if (
    !("tagAccessorialRules" in value) ||
    value["tagAccessorialRules"] === undefined
  )
    return false;
  if (
    !("tagLocationTypeRules" in value) ||
    value["tagLocationTypeRules"] === undefined
  )
    return false;
  if (
    !("excludedProductTags" in value) ||
    value["excludedProductTags"] === undefined
  )
    return false;
  return true;
}

export function ShopifyFreightSettingsFromJSON(
  json: any,
): ShopifyFreightSettings {
  return ShopifyFreightSettingsFromJSONTyped(json, false);
}

export function ShopifyFreightSettingsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ShopifyFreightSettings {
  if (json == null) {
    return json;
  }
  return {
    markup: CheckoutMarkupFromJSON(json["markup"]),
    deliveryDefaults: ShopifyDeliveryDefaultsFromJSON(json["deliveryDefaults"]),
    pickupLocationType: json["pickupLocationType"],
    pickupDistributionWarehouseBrand:
      json["pickupDistributionWarehouseBrand"] == null
        ? undefined
        : json["pickupDistributionWarehouseBrand"],
    pickupAccessorials: json["pickupAccessorials"],
    pickupLocations: (json["pickupLocations"] as Array<any>).map(
      ShopifyPickupLocationFromJSON,
    ),
    allowedCarriers: json["allowedCarriers"],
    blockedCarriers: json["blockedCarriers"],
    maxHandlingUnits: json["maxHandlingUnits"],
    maxRatesPerResponse: json["maxRatesPerResponse"],
    rateSelectors: (json["rateSelectors"] as Array<any>).map(
      CheckoutRateSelectorFromJSON,
    ),
    handlingTimeBusinessDays: json["handlingTimeBusinessDays"],
    dimensionMetafields:
      json["dimensionMetafields"] == null
        ? undefined
        : ShopifyDimensionMetafieldMappingFromJSON(json["dimensionMetafields"]),
    clearDimensionMetafields: json["clearDimensionMetafields"],
    handlingTimeMetafield:
      json["handlingTimeMetafield"] == null
        ? undefined
        : ShopifyHandlingTimeMetafieldMappingFromJSON(
            json["handlingTimeMetafield"],
          ),
    clearHandlingTimeMetafield: json["clearHandlingTimeMetafield"],
    palletization: ShopifyPalletizationConfigFromJSON(json["palletization"]),
    ratesEnabled: json["ratesEnabled"],
    tagAccessorialRules: (json["tagAccessorialRules"] as Array<any>).map(
      ShopifyTagAccessorialRuleFromJSON,
    ),
    tagLocationTypeRules: (json["tagLocationTypeRules"] as Array<any>).map(
      ShopifyTagLocationTypeRuleFromJSON,
    ),
    requiredCustomerTags:
      json["requiredCustomerTags"] == null
        ? undefined
        : json["requiredCustomerTags"],
    excludedProductTags: json["excludedProductTags"],
  };
}

export function ShopifyFreightSettingsToJSON(
  json: any,
): ShopifyFreightSettings {
  return ShopifyFreightSettingsToJSONTyped(json, false);
}

export function ShopifyFreightSettingsToJSONTyped(
  value?: ShopifyFreightSettings | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    markup: CheckoutMarkupToJSON(value["markup"]),
    deliveryDefaults: ShopifyDeliveryDefaultsToJSON(value["deliveryDefaults"]),
    pickupLocationType: value["pickupLocationType"],
    pickupDistributionWarehouseBrand: value["pickupDistributionWarehouseBrand"],
    pickupAccessorials: value["pickupAccessorials"],
    pickupLocations: (value["pickupLocations"] as Array<any>).map(
      ShopifyPickupLocationToJSON,
    ),
    allowedCarriers: value["allowedCarriers"],
    blockedCarriers: value["blockedCarriers"],
    maxHandlingUnits: value["maxHandlingUnits"],
    maxRatesPerResponse: value["maxRatesPerResponse"],
    rateSelectors: (value["rateSelectors"] as Array<any>).map(
      CheckoutRateSelectorToJSON,
    ),
    handlingTimeBusinessDays: value["handlingTimeBusinessDays"],
    dimensionMetafields: ShopifyDimensionMetafieldMappingToJSON(
      value["dimensionMetafields"],
    ),
    clearDimensionMetafields: value["clearDimensionMetafields"],
    handlingTimeMetafield: ShopifyHandlingTimeMetafieldMappingToJSON(
      value["handlingTimeMetafield"],
    ),
    clearHandlingTimeMetafield: value["clearHandlingTimeMetafield"],
    palletization: ShopifyPalletizationConfigToJSON(value["palletization"]),
    ratesEnabled: value["ratesEnabled"],
    tagAccessorialRules: (value["tagAccessorialRules"] as Array<any>).map(
      ShopifyTagAccessorialRuleToJSON,
    ),
    tagLocationTypeRules: (value["tagLocationTypeRules"] as Array<any>).map(
      ShopifyTagLocationTypeRuleToJSON,
    ),
    requiredCustomerTags: value["requiredCustomerTags"],
    excludedProductTags: value["excludedProductTags"],
  };
}
